import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
// @ts-expect-error module not typed
import { isDataEmpty } from 'conversations-message-history/email/operators/isDataEmpty';
import CommonMessageHeaderPopoverListItemDescription from './CommonMessageHeaderPopoverListItemDescription';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let OptionValueType;
(function (OptionValueType) {
  OptionValueType[OptionValueType["Email"] = 0] = "Email";
  OptionValueType[OptionValueType["PhoneNumber"] = 1] = "PhoneNumber";
  OptionValueType[OptionValueType["Date"] = 2] = "Date";
  OptionValueType[OptionValueType["Subject"] = 3] = "Subject";
  OptionValueType[OptionValueType["List"] = 4] = "List";
})(OptionValueType || (OptionValueType = {}));
const StyledDiv = styled.div.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDiv",
  componentId: "rn8nwj-0"
})(["display:contents;"]);
const StyledDt = styled.dt.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDt",
  componentId: "rn8nwj-1"
})(["display:inline;justify-self:end;"]);
const StyledDd = styled.dt.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDd",
  componentId: "rn8nwj-2"
})(["display:inline-flex;color:", " !important;margin-inline-start:", ";"], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.space[100]);
const StyledDlWrapper = styled.div.withConfig({
  displayName: "CommonMessageHeaderPopoverList__StyledDlWrapper",
  componentId: "rn8nwj-3"
})(["display:grid;grid-template-columns:auto auto;column-gap:8px;align-items:center;"]);
const CommonMessageHeaderPopoverList = ({
  options,
  genericChannelId
}) => {
  const renderDescriptionListItem = ({
    data,
    label,
    key
  }) => {
    if (isDataEmpty(data.value)) {
      return null;
    }
    return /*#__PURE__*/_jsxs(StyledDiv, {
      children: [/*#__PURE__*/_jsx(StyledDt, {
        children: label
      }), /*#__PURE__*/_jsx(StyledDd, {
        "data-call-metadata-type": key,
        "data-message-metadata-type": key,
        children: /*#__PURE__*/_jsx(CommonMessageHeaderPopoverListItemDescription, {
          name: data.name,
          value: data.value,
          valueType: data.valueType,
          copiableValue: data.copiableValue,
          genericChannelId: genericChannelId
        })
      })]
    }, key);
  };
  return /*#__PURE__*/_jsx(ScrollContainer, {
    maxHeight: 200,
    maxWidth: 450,
    children: /*#__PURE__*/_jsx(DescriptionList, {
      padding: "400",
      children: /*#__PURE__*/_jsx(StyledDlWrapper, {
        children: options.map(option => renderDescriptionListItem(option))
      })
    })
  });
};
CommonMessageHeaderPopoverList.displayName = 'CommonMessageHeaderPopoverList';
export default CommonMessageHeaderPopoverList;